import React from 'react'

const ReadOnlyContext = React.createContext(false);

export const ReadOnlyProvider = ReadOnlyContext.Provider;

export default ReadOnlyContext;
